import React from 'react';
import AmericanExpressCard from '|/icons/american-express-card.svg';
import CreditCard from '|/icons/credit-card.svg';
import DinersClubCard from '|/icons/diners-club-card.svg';
import DiscoverCard from '|/icons/discover-card.svg';
import JcbCard from '|/icons/jcb-card.svg';
import MastercardCard from '|/icons/mastercard-card.svg';
import UnionPayCard from '|/icons/union-pay-card.svg';
import VisaCard from '|/icons/visa-card.svg';

export interface CardBrandIconProps {
  brand?: string;
  width?: string | number;
  height?: string | number;
  className?: string;
  'aria-label'?: string;
}

const BRAND_COMPONENTS: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  Visa: VisaCard,
  Mastercard: MastercardCard,
  'American Express': AmericanExpressCard,
  Discover: DiscoverCard,
  JCB: JcbCard,
  'Diners Club': DinersClubCard,
  UnionPay: UnionPayCard
};

export const isKnownCardBrand = (brand?: string): boolean =>
  brand !== undefined && brand in BRAND_COMPONENTS;

export const ACCEPTED_CARD_BRANDS = ['Visa', 'Mastercard', 'American Express', 'Discover'] as const;

const CardBrandIcon: React.FC<CardBrandIconProps> = ({
  brand,
  width = '24px',
  height = '16px',
  className,
  'aria-label': ariaLabel
}) => {
  if (!brand) return null;
  const SvgComponent = BRAND_COMPONENTS[brand] ?? CreditCard;
  const resolvedAriaLabel = ariaLabel ?? (BRAND_COMPONENTS[brand] ? brand : 'Card');

  return (
    <SvgComponent
      width={width}
      height={height}
      className={className}
      role="img"
      aria-label={resolvedAriaLabel}
    />
  );
};

export default CardBrandIcon;
